@use "variables" as *;

.description {
  font-size: $fontSize-m;
  margin-bottom: $spacing-s;
}

.textField {
  min-width: 220px;
}
